// Floating Action Button avec sous-boutons

import React, { useState } from 'react';
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  useTheme,
} from '@mui/material';
import {
  Description,
  Receipt,
  PersonAdd,
  Work,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const DashboardFAB: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const actions = [
    {
      icon: <Description />,
      name: 'Nouveau Devis',
      onClick: () => {
        handleClose();
        navigate('/devis/new');
      },
    },
    {
      icon: <Receipt />,
      name: 'Nouvelle Facture',
      onClick: () => {
        handleClose();
        navigate('/factures/new');
      },
    },
    {
      icon: <Work />,
      name: 'Nouveau Projet',
      onClick: () => {
        handleClose();
        navigate('/projets/new');
      },
    },
    {
      icon: <PersonAdd />,
      name: 'Nouveau Client',
      onClick: () => {
        handleClose();
        navigate('/clients/new');
      },
    },
  ];

  return (
    <SpeedDial
      ariaLabel="Actions rapides"
      sx={{
        position: 'fixed',
        bottom: { xs: 90, sm: 24 }, // 90px en mobile pour éviter le chevauchement avec le menu (70px + marge)
        right: { xs: 16, sm: 24 },
      }}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      FabProps={{
        sx: {
          bgcolor: theme.palette.primary.main,
          '&:hover': {
            bgcolor: theme.palette.primary.dark,
          },
        },
      }}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          onClick={action.onClick}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              whiteSpace: 'nowrap',
              fontSize: '0.875rem',
            },
          }}
        />
      ))}
    </SpeedDial>
  );
};
